import React, { useEffect, useState } from 'react'

const Index = ({style}) => {

  return (
    <div style={style}>
       <div id="loading"></div>
  </div>
  )
}

export default Index;
